module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-rnd-quote.66eb103.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-rnd-quote.jpg
// module id = Y+no
// module chunks = 0